import { GdprRegions } from "./GdprRegions.js";
import { CcpaRegions } from "./CcpaRegions.js";
import { isNil, type Nil } from "@mcwd/typescript-type-guards";

export const PrivacyRegions = [
  ...GdprRegions,
  ...CcpaRegions
] as const;

export type PrivacyRegions = typeof PrivacyRegions[number];

export const PrivacyRegionMap = {
  GDPR: GdprRegions,
  CCPA: CcpaRegions
} as const;

export type RegionCodesObject =  { countryCode: string, stateOrTerritoryCode: string | Nil };
export type RegionNamesObject = { countryName: string, stateOrTerritoryName: string | Nil };

export type RegionNamesOrCodesObject = RegionNamesObject | RegionCodesObject;

function getPrivacyRegionFromRegionCodes({ countryCode, stateOrTerritoryCode }: RegionCodesObject)
{
  countryCode = countryCode?.trim().toUpperCase();
  stateOrTerritoryCode = stateOrTerritoryCode?.trim().toUpperCase() ?? null;
  if (countryCode === "") return null;
  if (stateOrTerritoryCode === "") stateOrTerritoryCode = null;

  if (countryCode === "UK") countryCode = "GB";
  const result = PrivacyRegions.find(region => {
    return (region.countryCode === countryCode) && (
      stateOrTerritoryCode === region.stateOrTerritoryCode || (
        isNil(stateOrTerritoryCode) && isNil(region.stateOrTerritoryCode)
      )
    );
  });
  return result ?? null;
}

function getPrivacyRegionFromRegionNames({ countryName, stateOrTerritoryName }: RegionNamesObject)
{
  countryName = countryName?.trim();
  stateOrTerritoryName = stateOrTerritoryName?.trim() ?? null;
  if (countryName === "") return null;
  if (stateOrTerritoryName === "") stateOrTerritoryName = null;

  const result = PrivacyRegions.find(region => {
    return (region.countryName === countryName) && (
      stateOrTerritoryName === region.stateOrTerritoryName || (
        isNil(stateOrTerritoryName) && isNil(region.stateOrTerritoryName)
      )
    );
  });
  return result ?? null;
}

export function getPrivacyRegionFromRegionNamesOrCodes(opts: RegionNamesOrCodesObject)
{
  if ("countryCode" in opts) {
    return getPrivacyRegionFromRegionCodes(opts);
  } else {
    return getPrivacyRegionFromRegionNames(opts);
  }
}

export function getPrivacyRuleFromRegion (opts: RegionNamesOrCodesObject)
{
  const result = getPrivacyRegionFromRegionNamesOrCodes(opts);
  return result?.privacyRule ?? null;
}
